import { render } from "./PayingOrgsLabel.vue?vue&type=template&id=b4982a88"
import script from "./PayingOrgsLabel.vue?vue&type=script&lang=js"
export * from "./PayingOrgsLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__